import { useState, useEffect } from "react";
import { COUNTDOWN_UPDATE_INTERVAL_MS } from "../constants/time-constants";

interface UseCountdownReturn {
    timeRemaining: number;
    isRevealed: boolean;
}

export const useCountdown = (revealDate: Date): UseCountdownReturn => {
    const [timeRemaining, setTimeRemaining] = useState(0);
    const [isRevealed, setIsRevealed] = useState(false);

    useEffect(() => {
        const now = new Date();
        const revealed = now >= revealDate;
        setIsRevealed(revealed);

        if (!revealed) {
            const updateCountdown = () => {
                const now = new Date();
                const diff = revealDate.getTime() - now.getTime();

                if (diff <= 0) {
                    setTimeRemaining(0);
                    setIsRevealed(true);
                } else {
                    setTimeRemaining(diff);
                }
            };

            updateCountdown();
            const interval = setInterval(
                updateCountdown,
                COUNTDOWN_UPDATE_INTERVAL_MS
            );

            return () => clearInterval(interval);
        }
    }, [revealDate]);

    return { timeRemaining, isRevealed };
};
